import React, { Component } from "react";
import { Form, Col, Input, Select, DatePicker } from "antd";
import ListPage from "../../../../../components/ListPage";

const ListFormSearch = ListPage.ListSearch;

const { Item } = Form;
const { Option } = Select;
const { RangePicker } = DatePicker;

@Form.create()
class Index extends Component {

  handleSearch = values => {
    const { handleQuery, type } = this.props;

    const { title, salaryStatus, rangePicker } = values;

    if (type === "mySalary") {
      handleQuery({
        queries: {
          startDate: (rangePicker && rangePicker[0]) ? rangePicker[0].format('YYYY-MM-DD') : '',
          endDate: (rangePicker && rangePicker[1]) ? rangePicker[1].format('YYYY-MM-DD') : '',
          title: title || "",
          readState: salaryStatus
        }
      });

    } else {
      handleQuery({
        queries: {
          sendStartTime: (rangePicker && rangePicker[0]) ? rangePicker[0].format('YYYY-MM-DD') : '',
          sendEndTime: (rangePicker && rangePicker[1]) ? rangePicker[1].format('YYYY-MM-DD') : '',
          title: title || "",
          salaryStatus
        }
      });
    }
  };

  handleReset = () => {
    const { handleQuery, type } = this.props;
    if (type === "mySalary") {
      handleQuery({
        queries: {
          startDate: '',
          endDate: '',
          title: ``,
          readState: ""
        }
      });

    } else {
      handleQuery({
        queries: {
          sendStartTime: '',
          sendEndTime: '',
          title: ``,
          salaryStatus: ""
        }
      });
    }

  };

  render() {

    const { form, statusList, type } = this.props;
    const { getFieldDecorator } = form;

    const formItemLayout = {
      colon: true,
      labelCol: {
        xs: { span: 8 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
      }
    };

    const searchProps = {
      form,
      btnSmSpan: 24,
      btnLgSpan: 24,
      handleQuery: this.handleSearch,
      handleReset: this.handleReset
    };

    return (
      <ListFormSearch {...searchProps}>
        <Col span={7}>
          <Item
            {...formItemLayout}
            label='搜索标题'
          >
            {getFieldDecorator("title", {
              rules: [{}]
            })(<Input placeholder="请搜索标题" />)}
          </Item>
        </Col>
        <Col span={10}>
          <Item
            label={type == 'mySalary' ? '接收日期' : "发布日期"}
            {...formItemLayout}
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 17 }}
          >
            {getFieldDecorator(
              `rangePicker`,
              {}
            )(<RangePicker format="YYYY-MM-DD" placeholder={["请选择", "请选择"]} />)}
          </Item>
        </Col>
        <Col span={7}>
          <Item
            {...formItemLayout}
            label={"查询状态"}
          >
            {getFieldDecorator("salaryStatus", {
              initialValue: "",
              rules: [{}]
            })(
              <Select>
                <Option value=''>全部</Option>
                {statusList.map(({ name, code, readState, }) => (
                  <Option value={`${type === "mySalary" ? readState : code}`}>{name}</Option>
                ))}
              </Select>
            )}
          </Item>
        </Col>
      </ListFormSearch>
    );
  }
}

export default Index;
